export const clientsData = [
  { id: 1, name: 'SLB', logo: '/clients/slb.png', url: 'https://www.slb.com/partners' },
  { id: 2, name: 'BGP', logo: '/clients/bgp.png', url: 'http://www.bgp.com.cn/' },
  { id: 3, name: 'CNPC', logo: '/clients/cnpc.png', url: 'http://ccde.cnpc.com.cn/worldwide/world_en.shtml' },
  { id: 4, name: 'Drillnetics', logo: '/clients/drillnetics .png', url: 'https://drillneticsenergy.com/' },
  { id: 5, name: 'Eastern Testing', logo: '/clients/eastern testing .png', url: 'https://www.eastern-testing.com/' },
  { id: 6, name: 'Hilong', logo: '/clients/hilong.png', url: 'http://www.hilonggroup.com/en/' },
  { id: 7, name: 'HPNIC', logo: '/clients/hpnic.png', url: 'https://www.hpinc.com/' },
  { id: 8, name: 'MOS', logo: '/clients/mos.png', url: 'https://www.icci.pk/listing/scomi-oiltools-ltd-pakistan-branch/' },
  { id: 9, name: 'OGDC', logo: '/clients/ogdd.png', url: 'https://www.ogdcl.com/' },
  { id: 10, name: 'Polaris', logo: '/clients/polaris.png', url: 'https://www.polarisgeo.com/' },
  { id: 11, name: 'Sprint', logo: '/clients/sprint .png', url: 'https://www.sprint-ogs.com/' },
];
